import React, { ComponentType } from 'react'
import style from './style/TPAErrorMessageOverlay.scss'
import _ from 'lodash'
import type { TPAWidgetBeckyProps } from '@wix/thunderbolt-components'

type TPAErrorMessageOverlayProps = {
	reload?: Function
	translations: TPAWidgetBeckyProps['translations']
	overlayState: string
	appDefinitionId: string
	appDefinitionName: string
	getParentWidth: () => number
}

export const TPAErrorMessageOverlay: ComponentType<TPAErrorMessageOverlayProps> = ({
	reload,
	translations,
	overlayState,
	appDefinitionId,
	appDefinitionName,
	getParentWidth,
}) => {
	const {
		errorMessageOverlay: {
			oopsText,
			installErrorText,
			uninstalledErrorText,
			generalErrorPrefix,
			generalErrorSuffix,
			reloadText,
		},
	} = translations

	const openHelp = (event: any) => {
		event.stopPropagation()
		window.parent.postMessage(
			JSON.stringify({
				intent: 'TPA_PREVIEW',
				callId: 0,
				type: 'openHelp',
				data: appDefinitionId,
			}),
			'*'
		)
	}

	const title = overlayState === 'unresponsive' ? oopsText : installErrorText

	const getUnresponsiveText = () => {
		const htmlText = _.template(generalErrorPrefix)({
			appName: appDefinitionName,
		})
		return [
			<span key="1" dangerouslySetInnerHTML={{ __html: htmlText }} />,
			// eslint-disable-next-line jsx-a11y/anchor-is-valid
			<a key="2" onClick={openHelp} href="#">
				{appDefinitionName}
			</a>,
			<span key="3">{generalErrorSuffix}</span>,
		]
	}

	const getUninstalledText = () => {
		const htmlText = uninstalledErrorText
		return [<span key="1" dangerouslySetInnerHTML={{ __html: htmlText }} />]
	}

	const text = overlayState === 'unresponsive' ? getUnresponsiveText() : getUninstalledText()

	const parentWidth = getParentWidth()
	const MIN_WIDTH_TEXT_DISPLAY = 224
	const textDisplay = parentWidth >= MIN_WIDTH_TEXT_DISPLAY

	const BORDER_SIZE = 2
	const outerWidth = parentWidth - 2 * BORDER_SIZE
	const widthIncludingPadding = Math.max(0, outerWidth)
	const hPadding = Math.floor(widthIncludingPadding * 0.1)
	const iconWidth = 45
	const contentWidth = widthIncludingPadding - 2 * hPadding

	const rootClassNames = [style.content, parentWidth > 175 ? style.iconLeft : style.iconTop].join(' ')
	const textContainerWidth = parentWidth > 175 ? contentWidth - iconWidth : '100%'

	return (
		<div className={rootClassNames}>
			<div className={style.headers}>
				<div className={style.iconContainer}>
					<svg width="22px" height="23px" viewBox="0 0 22 23">
						<title>!</title>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g
								id="Error-Message"
								transform="translate(-308.000000, -690.000000)"
								fill="#174165"
								fillRule="nonzero"
							>
								<g id="Group-3" transform="translate(66.000000, 75.000000)">
									<g id="Group-Copy" transform="translate(110.000000, 429.000000)">
										<g id="Group-2" transform="translate(128.000000, 186.000000)">
											<path
												d="M13.5652174,6 L16.4347826,6 L16.4347826,10.0908203 L15.9602582,13 L14.1082817,13 L13.5652174,10.0638428 L13.5652174,6 Z M13.5652174,14 L16.4347826,14 L16.4347826,17 L13.5652174,17 L13.5652174,14 Z M14.5217391,2 C9.76728781,2 5.91304348,6.02943725 5.91304348,11 L5.91304348,12 C5.91304348,16.9705627 9.76728781,21 14.5217391,21 L15.4782609,21 C20.2327122,21 24.0869565,16.9705627 24.0869565,12 L24.0869565,11 C24.0869565,6.02943725 20.2327122,2 15.4782609,2 L14.5217391,2 Z M14.5217391,0 L15.4782609,0 C21.2892569,0 26,4.92486775 26,11 L26,12 C26,18.0751322 21.2892569,23 15.4782609,23 L14.5217391,23 C8.71074307,23 4,18.0751322 4,12 L4,11 C4,4.92486775 8.71074307,0 14.5217391,0 Z"
												id="!"
											/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</svg>
				</div>
				<div className={style.textTitle}>{title}</div>
			</div>
			{textDisplay ? (
				<div className={style.textContainer} style={{ width: textContainerWidth }}>
					<span className={style.text}>{...text}</span>
					{reload ? (
						/* eslint-disable-next-line jsx-a11y/anchor-is-valid */
						<a className={style.reloadButton} onClick={() => reload()}>
							{reloadText}
						</a>
					) : null}
				</div>
			) : null}
		</div>
	)
}

export default TPAErrorMessageOverlay
